import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b658cc90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-content" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","margin-bottom":"40px","font-size":"28px","color":"#fff"} }, " 短剧数据管理平台 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_User = _resolveComponent("User")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_form, {
        model: _ctx.formState,
        name: "basic",
        "label-col": { span: 6 },
        autocomplete: "off",
        onFinish: _ctx.onFinish,
        onFinishFailed: _ctx.onFinishFailed
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "account",
            rules: [{ required: true, message: '请输入用户名!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                class: "input",
                value: _ctx.formState.account,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.account) = $event)),
                style: {"color":"#fff"}
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_User, {
                    type: "user",
                    style: {"color":"rgb(117, 136, 146)"}
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "password",
            rules: [{ required: true, message: '请输入密码!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                class: "input",
                value: _ctx.formState.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event))
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_Lock, {
                    type: "user",
                    style: {"color":"rgb(117, 136, 146)"}
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                loading: _ctx.loading,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登录")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish", "onFinishFailed"])
    ])
  ]))
}